export const CONFIG = {
    filesUrl: 'https://mindlab-zulu-files.s3.eu-central-1.amazonaws.com',
};
